<template>
  <vue-video-player
    ref="videoPlayer"
    class=""
    :options="playerOptions"
    v-on="$listeners"
    @ended="onPlayerEnded"
  />
</template>

<script>
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
import { videoPlayer } from 'vue-video-player'

export default {
  components: {
    'vueVideoPlayer': videoPlayer
  },
  props: {
    src: {
      required: false,
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    // videoStudyStatus: {
    //   type: Number
    // },
    hasProgress: {
      type: Boolean,
      default: true
    },
    list: {

    }

  },
  data() {
    return {
      playerOptions: {
        language: 'zh-CN',
        sources: [{
          // type: 'video/mp4',
          type: this.src.split('.')[this.src.split('.').length - 1] === 'm3u8' ? 'application/x-mpegURL' : 'video/mp4',
          src: this.list[0]
        }
        ],
        poster: '',
        controlBar: {
          fullscreenToggle: true,
          progressControl: {
            seekBar: this.hasProgress
          }
        },
        autoplay: true
      },
      flag: 0
    }
  },
  computed: {},
  watch: {
    src(value) {
      this.$set(this.playerOptions.sources, 0, {
        type: this.src.split('.')[this.src.split('.').length - 1] === 'm3u8' ? 'application/x-mpegURL' : 'video/mp4',
        src: value
      })
    }
  },
  mounted() {},
  methods: {
    onPlayerEnded() {
      // 下标 +1
      this.flag += 1
      // 放完从第一个播放 否则直接播放下一个
      if (this.flag + 1 > this.list.length) {
        this.flag = 0
        // this.playerOptions['sources'][0]['src'] = this.list[0]
        this.$refs.videoPlayer.player.src({ src: this.list[0], type: 'video/mp4' })
      } else {
        console.info(this.$refs.videoPlayer)
        // this.playerOptions['sources'][0]['src'] = this.list[this.flag]
        this.$refs.videoPlayer.player.src({ src: this.list[this.flag], type: 'video/mp4' })
      }
    }
  }
}
</script>

<style lang="scss">
.video-player {
  width: 100%;
  height: 460px;

  .video-js {
    width: 100%;
    height: 100%;
  }

  .vjs-big-play-button {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
}
</style>
